import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[680px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Cinematic%20dark%20abstract%20geometric%20background%20with%20flowing%20gradients%20of%20deep%20charcoal%20and%20warm%20amber%20light%20streaks%2C%20modern%20luxury%20cinema%20aesthetic%2C%20dramatic%20lighting%2C%20professional%20movie%20theater%20atmosphere%2C%20sophisticated%20entertainment%20backdrop%2C%20no%20text%20no%20people&width=1920&height=1080&seq=hero-bg-home&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
            <i className="ri-sparkling-line text-primary-500 text-sm"></i>
            <span className="text-xs font-medium text-primary-500 whitespace-nowrap">2026热门推荐</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 font-heading leading-tight mb-6">
            随时随地<br />畅享<span className="text-primary-500">高清内容</span>
          </h1>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-lg">
            无需下载，打开即看。海量高清影视、综艺、纪录片任意选择，支持多终端同步，流畅不卡顿。立即开启你的在线观看体验。
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <Link
              to="/category/all"
              className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              立即观看
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-lg border border-background-300/60 text-foreground-700 text-sm font-medium hover:border-foreground-700 hover:text-foreground-950 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center gap-6 mt-12">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">10万+</div>
              <div className="text-xs text-foreground-600 mt-1">精选内容</div>
            </div>
            <div className="w-px h-10 bg-background-300/60"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">5000万+</div>
              <div className="text-xs text-foreground-600 mt-1">活跃用户</div>
            </div>
            <div className="w-px h-10 bg-background-300/60"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">4K</div>
              <div className="text-xs text-foreground-600 mt-1">超清画质</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}